/**
 * Common Date Utilities for Consistent Formatting
 */

/**
 * Formats a UTC date string into a localized short date (e.g., "Apr 8, 2026")
 */
export const formatDate = (dateString) => {
  if (!dateString) return '';
  let str = dateString.toString();
  // Ensure the date string is treated as UTC if it's not already
  const date = new Date(str.includes('Z') || str.includes('+') ? str : str.replace(' ', 'T') + 'Z');

  if (isNaN(date.getTime())) return dateString;

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

/**
 * Formats a UTC date string into a localized date and time string (e.g., "4/8/2026, 01:58 PM")
 */
export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  let str = dateString.toString();
  // Ensure the date string is treated as UTC if it's not already
  const date = new Date(str.includes('Z') || str.includes('+') ? str : str.replace(' ', 'T') + 'Z');

  if (isNaN(date.getTime())) return dateString;

  return date.toLocaleString([], {
    hour: '2-digit',
    minute: '2-digit',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour12: true,
  });
};

/**
 * Formats a date specifically for "wall-clock" display with a separator (e.g., "April 8, 2026 at 01:58 pm")
 */
export const formatFullDateTime = (dateString) => {
  if (!dateString) return '';
  let str = dateString.toString();
  const date = new Date(str.includes('Z') || str.includes('+') ? str : str.replace(' ', 'T') + 'Z');

  if (isNaN(date.getTime())) return dateString;

  return (
    date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    }) +
    ' at ' +
    date
      .toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      })
      .toLowerCase()
  );
};
